import type { FunctionComponent } from 'react';

import PageWithVideoBackground from 'components/PageWithVideoBackground';
import { usePastSessions, useUserScores } from 'hooks';
import {
  useGlobalState,
} from 'utils';

import LeftCol from './LeftCol';
import RightCol from './RightCol';

import './style.scss';

const StatsPage: FunctionComponent = () => {
  const [userId] = useGlobalState('user.id');
  if (!userId) throw Error('Unauthenticated');

  const {
    aggregated,
    historical,
    loading: scoresLoading,
    scores,
  } = useUserScores();
  const { loading: sessionsLoading, sessions } = usePastSessions();

  return (
    <PageWithVideoBackground>
      <div styleName="pageContainer">
        <div styleName="contentWrapper">
          <LeftCol
            aggregated={aggregated}
            historical={historical}
            loading={scoresLoading || sessionsLoading}
            scores={scores}
            sessions={sessions}
            subtitle="Your Growth Progress"
            title="Growth Tracking"
          />
          <RightCol
            loading={sessionsLoading}
            sessions={sessions}
            title="Most searched"
          />
        </div>
      </div>
    </PageWithVideoBackground>
  );
};

export default StatsPage;
